
import { message } from "antd";
import axios from "axios";
import React, { useState, useEffect } from "react";
import LoadingBox from "../../Components/LoadingBox";
import { API, Headers } from "../../Config";
import PageHeader from "../../Routes/PageHeader";
import DataTable from "./DataTable";
import FormModal from "./FormModal";
import PdfRefNumModal from "./PdfRefNumModal";
import PrintRefNumberModal from "./PrintRefNumberModal";

function ReferenceNoGenScreen() {
  const [loading, setLoading] = useState(true);
  const [indicator, setIndicator] = useState(false);
  const [form, setForm] = useState(false);
  const [print, setPrint] = useState(false);
  const [data, setData] = useState([]);
  const [users, setUsers] = useState([]);
  const [item, setItem] = useState([]);
  const [item2, setItem2] = useState([]);
  const [page, setPage] = useState(1);
  const [take, setTake] = useState(10);
  const [meta, setMeta] = useState({});

  const [selected, setSelected] = useState([]);
  const [pdfview, setPdfView] = useState(false);

  useEffect(() => {
    loadData(page, take);
    loadUsers();
  }, []);

  const loadData = (p, t) => {
    try {
      axios
        .get(
          API.BASR_URL +
          API.REFERENCE_NUM_ACTIONS +
          `?order=DESC&page=${p}&take=${t}`,
          { headers: Headers() }
        )
        .then(function (response) {
          if (response?.status === 200) {
            let data = response.data;
            setData(data?.data);
            setMeta(data.meta);
            setLoading(false);
            setIndicator(false);
          }
        })
        .catch(function (error) {
          setLoading(false);
          setIndicator(false);
        });
    } catch (err) {
    }
  };

  const loadUsers = () => {
    try {
      axios
        .get(API.BASR_URL + API.USERS_LIST + `/list`, {
          headers: Headers(),
        })
        .then(function (response) {
          if (response.status === 200) {
            let data = response.data;
            setUsers(data);
          }
        });
    } catch (err) {
    }
  };

  const AddItem = () => {
    setForm(true);
  };

  const deleteItem = (item) => {
    setIndicator(true);
    axios
      .delete(API.BASR_URL + API.REFERENCE_NUM_ACTIONS + item.id, {
        headers: Headers(),
      })
      .then(function (response) {
        setIndicator(false);
        message.success("Deleted Successfully");
        reload();
      })
      .catch(function (error) {
        setIndicator(false);
        message.error("Oops.Something went wrong");
      });
  };

  const reload = () => {
    setForm(false);
    loadData(page, take);
  };

  const pagination = (page, take) => {
    window.scrollTo(0, 0);
    setIndicator(true);
    setPage(page);
    setTake(take);
    loadData(page, take);
  };

  const PrintRefNum = (val) => {
    let referenceNumbers = [];

    if (val?.numbers && typeof val.numbers === 'string' && val.numbers !== '[]' && val.numbers !== 'null') {
      try {
        const parsedNumbers = JSON.parse(val.numbers);
        if (Array.isArray(parsedNumbers) && parsedNumbers.length > 0) {
          referenceNumbers = parsedNumbers.map(item => {
            if (typeof item === 'string') {
              return item;
            } else if (item && typeof item === 'object') {
              return item.reference_number || item.refence_no || item.reference_no;
            }
            return item;
          }).filter(Boolean);
        }
      } catch (e) {
        if (val.numbers && val.numbers.length > 0) {
          referenceNumbers = [val.numbers];
        }
      }
    }

    if (referenceNumbers.length === 0 && val?.numbers && Array.isArray(val.numbers) && val.numbers.length > 0) {
      referenceNumbers = val.numbers.map(item => {
        if (typeof item === 'string') {
          return item;
        } else if (item && typeof item === 'object') {
          const refNum = item.reference_number || item.refence_no || item.reference_no;
          return refNum;
        }
        return item;
      }).filter(Boolean);
    }

    if (referenceNumbers.length === 0) {
      if (val?.refernce && Array.isArray(val.refernce) && val.refernce.length > 0) {
        referenceNumbers = val.refernce.map(item => {
          return item.refence_no || item.reference_no || item;
        }).filter(Boolean);
      } else if (val?.ref_line && Array.isArray(val.ref_line) && val.ref_line.length > 0) {
        referenceNumbers = val.ref_line.map(item => {
          return item.refence_no || item.reference_no || item;
        }).filter(Boolean);
      }
    }

    if (referenceNumbers.length === 0) {
      if (val?.refernce && Array.isArray(val.refernce) && val.refernce.length > 0) {
        referenceNumbers = val.refernce.map(item => {
          return item.refence_no || item.reference_no || item;
        }).filter(Boolean);
      } else if (val?.ref_line && Array.isArray(val.ref_line) && val.ref_line.length > 0) {
        referenceNumbers = val.ref_line.map(item => {
          return item.refence_no || item.reference_no || item;
        }).filter(Boolean);
      } else {
        if (val?.user_id && val?.id) {
          message.warning("No reference numbers found for this record. The data may not have been saved properly.");
        } else {
          message.warning("No reference numbers found for this record. The data may not have been saved properly.");
        }
      }
    }

    if (referenceNumbers.length > 0) {
      referenceNumbers.sort((a, b) => {
        const numA = parseInt(a.replace(/\D/g, '')) || 0;
        const numB = parseInt(b.replace(/\D/g, '')) || 0;
        return numA - numB;
      });
    }

    setPrint(true);
    setItem(referenceNumbers);
    setItem2(val);
  };

  const selectCell = (row) => {
    setSelected(row);
  };

  const generatePDF = (val) => {
    setPdfView(true);
  };

  return (
    <div>
      <PageHeader
        PageName={"Reference Number"}
        breadScrum={"Admin / ReferenceNum"}
        RightButton={"New Number "}
        RightClcik={() => AddItem()}
        loader={indicator}
      />
      {loading ? (
        <LoadingBox />
      ) : (
        <DataTable
          data={data}
          meta={meta}
          onSelect={(data) => selectCell(data)}
          generate={(val) => generatePDF(val)}
          pageOnChange={(page, take) => pagination(page, take)}
          print={(val) => PrintRefNum(val)}
          delete={(val) => deleteItem(val)}
        />
      )}
      {form ? (
        <FormModal
          visible={form}
          users={users}
          onClose={() => setForm(false)}
          reload={reload}
        />
      ) : null}
      {print ? (
        <PrintRefNumberModal
          visible={print}
          item={item}
          item2={item2}
          onCancel={() => setPrint(false)}
          reload={reload}
        />
      ) : null}
      {pdfview ? (
        <PdfRefNumModal
          visible={pdfview}
          onCancel={() => setPdfView(false)}
          selected={selected}
        />
      ) : null}
    </div>
  );
}

export default ReferenceNoGenScreen;